/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { DirectorStatusDTO } from './DirectorStatusDTO';

export type DirectorDetailsStepStatusDTO = {
    directorStatuses?: Array<DirectorStatusDTO>;
    upgradeTierStepStatus?: DirectorDetailsStepStatusDTO.upgradeTierStepStatus;
};

export namespace DirectorDetailsStepStatusDTO {

    export enum upgradeTierStepStatus {
        NOT_STARTED = 'NOT_STARTED',
        PENDING = 'PENDING',
        APPROVED = 'APPROVED',
        REJECTED = 'REJECTED',
    }


}

